import { folder, useControls } from "leva"

import useGame from "@stores/useGame";

export function Debug() {
    const changeBlockSize = useGame((state) => state.changeBlockSize);
    const changeControls = useGame((state) => state.changeControls);

    useControls({
        blocks: folder({
            size: {
                value: 4,
                step: 1,
                min: 4,
                max: 10,
                onChange: (value) => {
                    changeBlockSize(value);
                }
            },
        }, { collapsed: true }),
        enableOrbitControls: {
            value: false,
            onChange: (value) => {
                changeControls(value);
            }
        }
    });
}